function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP ToggleAddressFields
 * 
 */
import React from 'react';
import { connect } from 'react-redux';
import { addressFieldsToggle, addressDeliveryFieldsToggle } from '../../actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './ToggleAddressFields.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class ToggleAddressFields extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        focus
      } = this.state;
      if (focus && key === 'Enter') {
        this.toggle();
      }
    });
    /**
     * Toggle the address components
     */
    _defineProperty(this, "toggle", () => {
      const {
        addresses,
        name,
        addressFieldsToggle,
        addressDeliveryFieldsToggle
      } = this.props;
      switch (name) {
        case 'licenceDeliveryAddress':
          addressDeliveryFieldsToggle(!addresses.addressDeliveryFieldsToggle);
          break;
        default:
          addressFieldsToggle(!addresses.addressFieldsToggle);
      }
    });
    /**
     * toggle focus
     */
    _defineProperty(this, "focus", () => {
      this.setState({
        focus: !this.state.focus
      });
    });
    this.state = {
      focus: false
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  render() {
    const {
      addresses,
      name
    } = this.props;
    const {
      addressFieldsToggle,
      addressDeliveryFieldsToggle,
      licenceDelivery
    } = addresses;
    const toggle = name === 'licenceAddress' && addressFieldsToggle || name === 'licenceDeliveryAddress' && addressDeliveryFieldsToggle;
    const content = toggle ? /*#__PURE__*/_jsxs("span", {
      children: ["Try ", /*#__PURE__*/_jsx("span", {
        className: "link",
        children: "searching for your address"
      }), " instead."]
    }) : /*#__PURE__*/_jsxs("span", {
      children: ["If your address does not appear, or is incorrect, ", /*#__PURE__*/_jsx("span", {
        className: "link",
        children: "you can enter it manually."
      })]
    });
    return licenceDelivery === 'International' && name === 'licenceDeliveryAddress' ? null : /*#__PURE__*/_jsxs("div", {
      className: "address-toggle",
      onClick: this.toggle,
      tabIndex: "0",
      onFocus: this.focus,
      onBlur: this.focus,
      role: "button",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: toggle ? 'search' : 'pencil',
        className: "left"
      }), content]
    });
  }
}
_defineProperty(ToggleAddressFields, "defaultProps", {
  name: 'licenceAddress',
  addresses: {
    addressFieldsToggle: false,
    licenceDelivery: 'Australian'
  }
});
const mapStateToProps = ({
  addresses
}) => {
  return {
    addresses
  };
};
const mapDispatchToProps = dispatch => {
  return {
    addressFieldsToggle: value => {
      dispatch(addressFieldsToggle(value));
    },
    addressDeliveryFieldsToggle: value => {
      dispatch(addressDeliveryFieldsToggle(value));
    }
  };
};
const VisibleToggleAddressFields = connect(mapStateToProps, mapDispatchToProps)(ToggleAddressFields);
export default VisibleToggleAddressFields;